import { createSlice } from "@reduxjs/toolkit";
const initialState =
{
  UserID: "",
  UserName: "",
  UserGroupCode: "",
  UserGroupName: "",
  IP:"",
  UserRights:{},
};

const loginSlice = createSlice({
  name: "login",
  initialState: { value: initialState },

  reducers: {
    loginSuccess: (state, action) => {
      state.value = action.payload;
    },
    loginUserRights: (state, action) => {
      state.value.UserRights = action.payload.UserRights;
    },

    Logout: (state) => {
      state.value = initialState;
    },
  },
});

export const { loginSuccess, Logout,loginUserRights } = loginSlice.actions;
export default loginSlice.reducer;
